import axios from "axios";
import {API_BASE_URL_V2} from "../../../services/config";

// Forgot password standard user
export const forgotPasswordService = async (email: string) => {
  const normalizedEmail = email.toLowerCase();

  // GET with path params
  const response = await axios.get(
    `${API_BASE_URL_V2}auth/forgot-password/${normalizedEmail}`
  );
  return response.data;
};

// Recover account (Reset password)
export const newPasswordService = async (payload: {
  password: string;
  confirmPassword: string;
  link: string;
}) => {
  // PATCH /auth/recover-password (body: {link, password, confirmPassword})
  const response = await axios.patch(API_BASE_URL_V2 + "auth/recover-password", {
    link: payload.link,
    password: payload.password,
    confirmPassword: payload.confirmPassword,
  });
  return response.data;
};
